<script>
  import { _ } from 'svelte-i18n'
  import { createEventDispatcher } from 'svelte'
  import Button from '../elements/Button.svelte'
  import Blink from '../elements/Blink.svelte'
  export let selected_plan = "yearly"
  export let subscription_type = "business" // "pro" or "business"
  export let disabled = false
  export let processing = false
  const dispatch = createEventDispatcher()
  
  function handleClick() {
    if (disabled || processing) return
    // Get product id
    const product_str = 'wordmark-' + subscription_type + '-'
    const plan_str = selected_plan === 'yearly' ? '12' : 'monthly'
    const product_id = product_str + plan_str + "-subscription"
    
    dispatch('change', {
      product_id,
      subscription_type,
      selected_plan
    });
  }

  // Get the appropriate button text based on subscription type 
  $: buttonText = subscription_type === 'business' 
    ? $_('buttons.upgradeTo') + '<b>' + $_('app.businessName') + '</b>'
    : $_('buttons.subscribeTo') + '<b>' + $_('app.proName') + '</b>'
</script>

<Button kind="accent-orange" on:click={handleClick} disabled={disabled || processing}>
  {#if processing}
    <Blink>{$_('buttons.processing')}</Blink>
  {:else}
    {@html buttonText}
  {/if}
</Button>